var React = require('react');

function GoldenSection180 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M703.322 0C897.559 0 1055 157.816 1055 352.516C1055 547.184 897.559 705 703.322 705L0 705C0 315.632 314.881 0 703.29 0","fill":"currentColor"}));
}

GoldenSection180.defaultProps = {"width":"1055","height":"705","viewBox":"0 0 1055 705","fill":"none"};

module.exports = GoldenSection180;

GoldenSection180.default = GoldenSection180;
